import { useMutation } from "@tanstack/react-query";
import {
  VerifyBankDetailData,
  VerifyBankDetailPayload,
  verifyOtcBankDetail,
} from "../services";
import { getApiErrorMessage } from "../../../shared/lib";

export interface UseVerifyBankDetailOptions {
  source?: string;
}

export const useVerifyBankDetail = (options?: UseVerifyBankDetailOptions) => {
  const mutation = useMutation<
    VerifyBankDetailData | null,
    Error,
    VerifyBankDetailPayload
  >({
    mutationFn: (payload) =>
      verifyOtcBankDetail(payload, payload.source || options?.source),
  });

  return {
    verify: mutation.mutate,
    verifyAsync: mutation.mutateAsync,
    reset: mutation.reset,
    isVerifying: mutation.isPending,
    verifiedData: mutation.data ?? null,
    error: mutation.error
      ? getApiErrorMessage(mutation.error, "Could not verify bank account details")
      : null,
  };
};
